// extracted by mini-css-extract-plugin
export default {"header":"qim7hi3GzILlHrRmFo7G","header__title":"Z2_kc_uhf9qk7QyTJk1w"};